import React from "react";
import moment from "moment";
import DatePicker from "react-datepicker";
import { Controller } from "react-hook-form";
import { useProduccionForm } from "../hooks/useProduccionForm";
import LoadMask from "Utils/LoadMask/LoadMask";
import { OrdenesProduccion } from "./OrdenesProduccion/OrdenesProduccion";
import { ResumenTotal } from "./ResumenTotal";
import {
    getWeekRange,
    getWeeksInYear,
    LOCALE_CALENDARIO_DOMINGO,
} from "../../../../helpers/dateRange";

export const ProduccionForm = ({ idProduccion, regresar }) => {
    const prodFormHook = useProduccionForm(idProduccion, regresar);

    const {
        formControl,
        formRegister,
        formErrors,
        formWatch,
        formGetValues,
        formSetValue,
        validateForm,

        ordenesProduccion,
        FormSubmit,
        cargando,

        isProduccionPendiente,
    } = prodFormHook;

    // --------------------------------------------------------------
    // Validaciones y efectos relacionados con el año y la semana
    // --------------------------------------------------------------
    const semana = formWatch("semana");
    const anio = formWatch("anio");

    const RecalcularRangoSemanal = () => {        
        if (!semana || !anio) return;

        const { start, end } = getWeekRange(semana, anio);

        formSetValue("fecha_inicial", moment(start));
        formSetValue("fecha_final", moment(end));

        validateForm("fecha_inicial");
        validateForm("fecha_final");
    };

    return (
        <LoadMask loading={cargando} blur>
            <div className="formulario-fields-row">
                <div className="formulario-field">
                    <label className="text-nowrap">No. Producción</label>
                    <input
                        type="text"
                        className={`form-control ${formErrors.numero ? "is-invalid" : ""}`}
                        {...formRegister("numero", {
                            required: "Este campo es obligatorio",
                        })}
                        disabled
                    />
                    {formErrors.numero && (
                        <small className="text-danger">
                            {formErrors.numero.message}
                        </small>
                    )}
                </div>
                <div className="formulario-field" style={{ minWidth: "100px" }}>
                    <label className="text-nowrap">Año</label>
                    <input
                        type="number"
                        className="form-control"
                        value={anio || ""}
                        disabled
                    />
                </div>

                <div className="formulario-field" style={{ minWidth: "100px" }}>
                    <label className="text-nowrap">Semana</label>
                    <Controller
                        name="semana"
                        control={formControl}
                        rules={{
                            required: "Este campo es obligatorio",
                            min: { value: 1, message: "Mínimo 1" },
                            max: {
                                value: getWeeksInYear(anio),
                                message: "Semana inválida para ese año",
                            },
                        }}
                        render={({ field }) => (
                            <input
                                type="number"
                                min={1}
                                max={getWeeksInYear(anio)}
                                className={`form-control ${formErrors.semana ? "is-invalid" : ""}`}
                                disabled={!isProduccionPendiente}
                                {...field}
                                onChange={(e) => {
                                    field.onChange(e);
                                    RecalcularRangoSemanal();
                                }}
                            />
                        )}
                    />
                    {formErrors.semana && (
                        <small className="text-danger">
                            {formErrors.semana.message}
                        </small>
                    )}
                </div>
                <div className="formulario-field" style={{ minWidth: "120px" }}>
                    <label className="text-nowrap">Fecha inicial</label>
                    <Controller
                        name="fecha_inicial"
                        control={formControl}
                        rules={{
                            required: "Este campo es obligatorio",
                        }}
                        render={({ field }) => (
                            <DatePicker
                                selected={field.value}
                                onChange={(date) => {
                                    field.onChange(date);
                                }}
                                showPopperArrow={false}
                                locale={LOCALE_CALENDARIO_DOMINGO}
                                dateFormat="DD/MM/YYYY"
                                placeholderText="Fecha de inicio"
                                maxDate={formControl._formValues.fecha_final}
                                disabled={!isProduccionPendiente}
                            />
                        )}
                    />
                    {formErrors.fecha_inicial && (
                        <small className="text-danger">
                            {formErrors.fecha_inicial.message}
                        </small>
                    )}
                </div>
                <div className="formulario-field" style={{ minWidth: "120px" }}>
                    <label className="text-nowrap">Fecha final</label>
                    <Controller
                        name="fecha_final"
                        control={formControl}
                        rules={{
                            required: "Este campo es obligatorio",
                        }}
                        render={({ field }) => (
                            <DatePicker
                                selected={field.value}
                                onChange={(date) => {
                                    field.onChange(date);
                                }}
                                showPopperArrow={false}
                                locale={LOCALE_CALENDARIO_DOMINGO}
                                dateFormat="DD/MM/YYYY"
                                placeholderText="Fecha final"
                                minDate={formControl._formValues.fecha_inicial}
                                disabled={!isProduccionPendiente}
                            />
                        )}
                    />
                    {formErrors.fecha_final && (
                        <small className="text-danger">
                            {formErrors.fecha_final.message}
                        </small>
                    )}
                </div>
            </div>
            <OrdenesProduccion prodFormHook={prodFormHook} />
            <ResumenTotal ordenesProduccion={ordenesProduccion} />
            <div className="d-flex justify-content-center mt-3 gap-1rem">
                <button className="btn btn-outline-dark" onClick={regresar}>
                    Regresar
                </button>
                {/* Este botón actualiza datos generales de la producción */}
                {isProduccionPendiente && (
                    <button className="btn btn-primary" onClick={FormSubmit}>
                        Guardar
                    </button>
                )}
            </div>
        </LoadMask>
    );
};
